import React, {useEffect, useState} from 'react'
import APPRAISAL_ACTIONS from './state/appraisalPageActions'
import MarketValueSummaryV1 from './components/marketValueSummaryV1'
import MarketValueSummaryV2 from './components/marketValueSummaryV2'


function AppraisalPage({id}){
  const [appraisalInfo, setAppraisalInfo] = useState(null)
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token')

  useEffect(()=>{
    APPRAISAL_ACTIONS.getAppraisalInfo(token).then(response=>{
      return(response.json())
    }).then(res=>{
      if(res){
        setAppraisalInfo(res)
      }
    }).catch(error=>{
      console.error(error)
    })
  },[])

  if (appraisalInfo?.enhanced_summary_enabled){
    return <MarketValueSummaryV2 appraisalInfo={appraisalInfo} />
  }

  return <MarketValueSummaryV1 appraisalInfo={appraisalInfo} />
}


export default AppraisalPage
